import { api } from '../index'

export interface CreateUserListCampaignParams {
  userListId: number
  listName: string
}

interface CreateCampaignApiResponse {
  campaign: {
    id: number
    type: string
    state: string
    name: string
    created_at: string
  }
}

export interface CreateCampaignResponse {
  campaign: {
    id: number
    type: string
    state: string
    name: string
    createdAt: string
  }
}

export const createUserListCampaignApi = api.injectEndpoints({
  endpoints: builder => ({
    createUserListCampaign: builder.mutation<
      CreateCampaignResponse,
      CreateUserListCampaignParams
    >({
      query: ({ userListId, listName }) => ({
        url: 'campaigns',
        method: 'POST',
        body: {
          campaign: {
            type: 'custom',
            name: `Target Customer List ${listName}`,
            target_segment_id: userListId,
          },
        },
      }),
      transformResponse: (response: CreateCampaignApiResponse) => ({
        campaign: {
          id: response.campaign.id,
          type: response.campaign.type,
          state: response.campaign.state,
          name: response.campaign.name,
          createdAt: response.campaign.created_at,
        },
      }),
      invalidatesTags: (_result, _error, { userListId }) => [
        { type: 'UserList', id: `${userListId}-campaigns` },
      ],
    }),
  }),
})

export const { useCreateUserListCampaignMutation } = createUserListCampaignApi
